// TreeStructure.js - С ИСПРАВЛЕННОЙ логикой GET-параметров и навигации
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    ChevronUp, Users, Calendar, Award, MessageCircle, AlertCircle,
    Box, ChevronDown, ArrowUpCircle, ChevronsLeft, User, Trophy,
    Lock, ShoppingCart, X, Sparkles, CheckCircle, Zap, TrendingUp, Plus,
    Search, Cpu, ChevronRight, DollarSign, Package, Clock, RefreshCw
} from 'lucide-react';
import marketingService from '../services/marketingService';
import { UltraModernCard } from './UltraModernCard';
import PositionHistoryModal from './PositionHistoryModal';
import ClonesInfoModal from './ClonesInfoModal';
import Nt from './Nt';
// ===== МОДАЛЬНЫЕ ОКНА =====

// ===== МОДАЛЬНОЕ ОКНО ПОКУПКИ УРОВНЯ =====

const BuyLevelModal = ({ isOpen, onClose, tarif, level, displayTarif, onSuccess, onError }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const response = await marketingService.buyLevelDirect(tarif, level);

            if (response.success) {
                onSuccess(response.message || 'Уровень успешно куплен и добавлен в очередь на расстановку!');
                onClose();
            } else {
                onError(response.message || 'Ошибка при покупке уровня');
            }
        } catch (error) {
            onError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in">
                <div className="bg-gradient-to-r from-green-500 to-emerald-500 p-6 text-white">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="w-12 h-12 rounded-full bg-white bg-opacity-20 flex items-center justify-center">
                                <DollarSign size={24} />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold">Покупка уровня</h3>
                                <p className="text-green-100 text-sm">Подтвердите действие</p>
                            </div>
                        </div>
                        <button onClick={onClose} className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition">
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <div className="p-6">
                    <div className="space-y-4">
                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-4 border border-green-200">
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-sm text-gray-600">Тариф:</span>
                                <span className="font-bold text-gray-800">{displayTarif}</span>
                            </div>
                            <div className="flex items-center justify-between mb-2">
                                <span className="text-sm text-gray-600">Уровень:</span>
                                <span className="font-bold text-gray-800">{level}</span>
                            </div>
                            <div className="pt-3 border-t border-green-200 mt-3">
                                <div className="flex items-center justify-between">
                                    <span className="font-semibold text-gray-700">Стоимость:</span>
                                    <span className="text-2xl font-bold text-green-600">{level} $</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                            <div className="flex items-start gap-3">
                                <AlertCircle size={20} className="text-blue-500 flex-shrink-0 mt-0.5" />
                                <div className="text-sm text-blue-800">
                                    <p className="font-medium mb-1">Что произойдет после оплаты:</p>
                                    <ul className="space-y-1 text-xs">
                                        <li>• Средства будут списаны с вашего баланса</li>
                                        <li>• Уровень будет добавлен в очередь на автоматическую расстановку</li>
                                        <li>• Вы получите уведомление о расстановке</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-3 mt-6">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition font-medium"
                            disabled={loading}
                        >
                            Отмена
                        </button>
                        <button
                            onClick={handleConfirm}
                            className="flex-1 px-4 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg hover:shadow-lg transition font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                                    <span>Обработка...</span>
                                </>
                            ) : (
                                <>
                                    <DollarSign size={18} />
                                    <span>Купить</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const BookingModal = ({ isOpen, onClose, position, tarif, level, numberLevel, onSuccess, onError }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const response = await marketingService.bronPosition({
                program: 1,
                tarif,
                level,
                number_level: numberLevel,
                mentor_id: position.mentor_id,
                position: position.position
            });

            if (response.success) {
                onSuccess(response.message || 'Позиция успешно забронирована!');
                onClose();
            } else {
                onError(response.message || 'Ошибка бронирования');
            }
        } catch (error) {
            onError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in">
                <div className="bg-gradient-to-r from-blue-500 to-teal-500 p-6 text-white">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="w-12 h-12 rounded-full bg-white bg-opacity-20 flex items-center justify-center">
                                <Lock size={24} />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold">Бронирование места</h3>
                                <p className="text-blue-100 text-sm">Зарезервируйте позицию</p>
                            </div>
                        </div>
                        <button onClick={onClose} disabled={loading}
                                className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition">
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <div className="p-6 space-y-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                        <div className="flex items-start space-x-3">
                            <AlertCircle className="text-blue-500 mt-1 flex-shrink-0" size={20} />
                            <div className="text-sm text-blue-800">
                                <p className="font-semibold mb-1">Информация о бронировании:</p>
                                <ul className="list-disc list-inside space-y-1 text-blue-700">
                                    <li>Позиция #{position?.position} будет забронирована за вами</li>
                                    <li>Бронь действует 24 часа</li>
                                    <li>Вы сможете оплатить позицию в любое время</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-4 space-y-2">
                        <div className="flex justify-between">
                            <span className="text-gray-600">Позиция:</span>
                            <span className="font-semibold">#{position?.position}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600">Наставник:</span>
                            <span className="font-semibold">ID {position?.mentor_id}</span>
                        </div>
                    </div>

                    <div className="flex space-x-3 pt-2">
                        <button onClick={onClose} disabled={loading}
                                className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition font-medium disabled:opacity-50">
                            Отмена
                        </button>
                        <button onClick={handleConfirm} disabled={loading}
                                className="flex-1 px-4 py-3 bg-gradient-to-r from-blue-500 to-teal-500 text-white rounded-lg hover:shadow-lg transition font-medium disabled:opacity-50 flex items-center justify-center space-x-2">
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                    <span>Бронирование...</span>
                                </>
                            ) : (
                                <>
                                    <Lock size={18} />
                                    <span>Забронировать</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PurchaseModal = ({ isOpen, onClose, position, tarif, level, numberLevel, price, onSuccess, onError }) => {
    const [cloneType, setCloneType] = useState('normal');
    const [loading, setLoading] = useState(false);
    // 🆕 НОВОЕ: Состояние для клонов
    const [clonesInfo, setClonesInfo] = useState(null);
    const [loadingClones, setLoadingClones] = useState(true);

    // 🆕 НОВОЕ: Загружаем информацию о клонах при открытии модалки
    useEffect(() => {
        if (isOpen) {
            loadClonesInfo();
        }
    }, [isOpen, tarif, level, numberLevel]);

    const loadClonesInfo = async () => {
        setLoadingClones(true);
        try {
            const response = await marketingService.getClonesInfo({
                tarif,
                level,
                number_level: numberLevel
            });

            if (response.success) {
                setClonesInfo(response.data);
            }
        } catch (error) {
            console.error('Error loading clones info:', error);
        } finally {
            setLoadingClones(false);
        }
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const response = await marketingService.payPosition({
                program: 1,
                tarif,
                level,
                number_level: numberLevel,
                mentor_id: position.mentor_id,
                position: position.position,
                clone_type: cloneType
            });

            if (response.success) {
                const message = response.data.used_clone
                    ? `${cloneType === 'normal' ? 'Обычный' : 'Технический'} клон успешно установлен из банка клонов!`
                    : `${cloneType === 'normal' ? 'Обычный' : 'Технический'} клон успешно куплен за ${response.data.paid_amount}$!`;

                onSuccess(message);
                onClose();
            } else {
                onError(response.message || 'Ошибка покупки');
            }
        } catch (error) {
            onError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in">
                <div className="bg-gradient-to-r from-teal-500 to-emerald-500 p-6 text-white">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="w-12 h-12 rounded-full bg-white bg-opacity-20 flex items-center justify-center">
                                <ShoppingCart size={24} />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold">Покупка позиции</h3>
                                <p className="text-teal-100 text-sm">Выберите тип клона</p>
                            </div>
                        </div>
                        <button onClick={onClose} disabled={loading}
                                className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition">
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <div className="p-6 space-y-4">
                    {loadingClones ? (
                        <div className="flex justify-center py-4">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-500"></div>
                        </div>
                    ) : (
                        <div>
                            {clonesInfo && clonesInfo.normal_clones > 0 && (
                                <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
                                    <div className="flex items-center gap-2 text-green-700 text-sm">
                                        <CheckCircle size={16} />
                                        <span>Будет списано с баланса: <strong>{price}$</strong></span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                            Тип клона:
                        </label>
                        <div className="grid grid-cols-2 gap-3">
                            <button onClick={() => setCloneType('normal')}
                                    disabled={loading}
                                    className={`p-4 rounded-xl border-2 transition ${
                                        cloneType === 'normal'
                                            ? 'border-teal-500 bg-teal-50'
                                            : 'border-gray-200 hover:border-gray-300'
                                    } disabled:opacity-50`}>
                                <div className="flex items-center justify-center mb-2">
                                    <Sparkles className={cloneType === 'normal' ? 'text-teal-500' : 'text-gray-400'} size={24} />
                                </div>
                                <div className="text-sm font-semibold text-gray-800">Обычный</div>
                                {!loadingClones && clonesInfo && clonesInfo.normal_clones > 0 && (
                                    <div className="text-xs text-green-600 mt-1 font-medium">
                                        ✓ Доступно {clonesInfo.normal_clones} шт
                                    </div>
                                )}
                            </button>
                            <button onClick={() => setCloneType('technical')}
                                    disabled={loading}
                                    className={`p-4 rounded-xl border-2 transition ${
                                        cloneType === 'technical'
                                            ? 'border-teal-500 bg-teal-50'
                                            : 'border-gray-200 hover:border-gray-300'
                                    } disabled:opacity-50`}>
                                <div className="flex items-center justify-center mb-2">
                                    <Cpu className={cloneType === 'technical' ? 'text-teal-500' : 'text-gray-400'} size={24} />
                                </div>
                                <div className="text-sm font-semibold text-gray-800">Технический</div>
                                <div className="text-xs text-gray-500 mt-1">Всегда платно</div>
                            </button>
                        </div>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-4 space-y-3">
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600">Тип клона:</span>
                            <span className="font-semibold text-gray-800">{cloneType === 'normal' ? 'Обычный' : 'Технический'}</span>
                        </div>
                        <div className="h-px bg-gray-200"></div>
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600">Позиция:</span>
                            <span className="font-semibold">#{position?.position}</span>
                        </div>
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600">Наставник:</span>
                            <span className="font-semibold">ID {position?.mentor_id}</span>
                        </div>
                        <div className="h-px bg-gray-200"></div>
                        <div className="flex justify-between text-lg items-center">
                            <span className="font-semibold text-gray-700">Стоимость:</span>
                            {!loadingClones && clonesInfo && cloneType === 'normal' && clonesInfo.normal_clones > 0 ? (
                                <div className="flex flex-col items-end">
                                    <span className="text-gray-400 line-through text-sm">{price} $</span>
                                    <span className="font-bold text-green-600">Бесплатно</span>
                                </div>
                            ) : (
                                <span className="font-bold text-teal-600">{price} $</span>
                            )}
                        </div>
                    </div>

                    <div className="flex space-x-3 pt-2">
                        <button onClick={onClose} disabled={loading}
                                className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition font-medium disabled:opacity-50">
                            Отмена
                        </button>
                        <button onClick={handleConfirm} disabled={loading}
                                className="flex-1 px-4 py-3 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-lg hover:shadow-lg transition font-medium disabled:opacity-50 flex items-center justify-center space-x-2">
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                    <span>Покупка...</span>
                                </>
                            ) : (
                                <>
                                    <ShoppingCart size={18} />
                                    <span>Купить</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SuccessModal = ({ isOpen, onClose, message, type }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden animate-fade-in">
                <div className={`p-6 ${type === 'success' ? 'bg-green-50' : 'bg-red-50'}`}>
                    <div className="flex flex-col items-center text-center space-y-4">
                        <div className={`w-16 h-16 rounded-full flex items-center justify-center ${
                            type === 'success' ? 'bg-green-100' : 'bg-red-100'
                        }`}>
                            {type === 'success' ? (
                                <CheckCircle className="text-green-500" size={32} />
                            ) : (
                                <AlertCircle className="text-red-500" size={32} />
                            )}
                        </div>
                        <div>
                            <h3 className={`text-xl font-bold mb-2 ${
                                type === 'success' ? 'text-green-800' : 'text-red-800'
                            }`}>
                                {type === 'success' ? 'Успешно!' : 'Ошибка'}
                            </h3>
                            <p className={type === 'success' ? 'text-green-700' : 'text-red-700'}>
                                {message}
                            </p>
                        </div>
                        <button onClick={onClose}
                                className={`w-full py-3 rounded-lg font-medium transition ${
                                    type === 'success'
                                        ? 'bg-green-500 text-white hover:bg-green-600'
                                        : 'bg-red-500 text-white hover:bg-red-600'
                                }`}>
                            Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ===== 🆕 МОДАЛЬНОЕ ОКНО ПРОДЛЕНИЯ АКТИВНОСТИ =====
const RenewActivityModal = ({ isOpen, onClose, onSuccess, onError }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const response = await marketingService.renewActivity();
            if (response.success) {
                onSuccess(response.message || 'Активность продлена на 6 месяцев. Клон зачислен в тариф Start.');
                onClose();
            } else {
                onError(response.message || 'Ошибка при продлении активности');
            }
        } catch (error) {
            onError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in">
                <div className="bg-gradient-to-r from-indigo-500 to-purple-500 p-6 text-white">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center space-x-3">
                            <div className="w-12 h-12 rounded-full bg-white bg-opacity-20 flex items-center justify-center">
                                <RefreshCw size={24} />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold">Продление активности</h3>
                                <p className="text-indigo-100 text-sm">Подтвердите действие</p>
                            </div>
                        </div>
                        <button onClick={onClose} disabled={loading}
                                className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition">
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <div className="p-6 space-y-4">
                    <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4">
                        <div className="flex items-start space-x-3">
                            <AlertCircle className="text-indigo-500 mt-1 flex-shrink-0" size={20} />
                            <div className="text-sm text-indigo-800">
                                <p className="font-semibold mb-2">Что произойдёт:</p>
                                <ul className="space-y-1 text-indigo-700">
                                    <li>• Спишется <strong>5 USD</strong> с вашего баланса</li>
                                    <li>• Активность продлится на <strong>6 месяцев</strong></li>
                                    <li>• Начислится <strong>1 клон</strong> в тариф Start (уровень 1)</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-4 flex justify-between items-center">
                        <span className="font-semibold text-gray-700">Стоимость:</span>
                        <span className="text-2xl font-bold text-indigo-600">5 USD</span>
                    </div>

                    <div className="flex space-x-3 pt-2">
                        <button onClick={onClose} disabled={loading}
                                className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition font-medium disabled:opacity-50">
                            Отмена
                        </button>
                        <button onClick={handleConfirm} disabled={loading}
                                className="flex-1 px-4 py-3 bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-lg hover:shadow-lg transition font-medium disabled:opacity-50 flex items-center justify-center space-x-2">
                            {loading ? (
                                <>
                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                                    <span>Продление...</span>
                                </>
                            ) : (
                                <>
                                    <RefreshCw size={18} />
                                    <span>Продлить</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ===== 🆕 ТАЙМЕР ОБРАТНОГО ОТСЧЁТА ПОДПИСКИ =====
const SubscriptionTimer = ({ subscribedUntil }) => {
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        if (!subscribedUntil) {
            setTimeLeft(null);
            return;
        }
        const calc = () => {
            const diff = new Date(subscribedUntil) - new Date();
            setTimeLeft(diff);
        };
        calc();
        const id = setInterval(calc, 1000);
        return () => clearInterval(id);
    }, [subscribedUntil]);

    if (!subscribedUntil) {
        return (
            <div className="flex items-center gap-1.5 px-3 py-2 bg-gray-100 text-gray-500 rounded-lg text-xs font-medium">
                <Clock size={14} />
                <span>Нет подписки</span>
            </div>
        );
    }

    if (timeLeft !== null && timeLeft <= 0) {
        return (
            <div className="flex items-center gap-1.5 px-3 py-2 bg-red-100 text-red-700 rounded-lg text-xs font-medium">
                <Clock size={14} />
                <span>Подписка истекла</span>
            </div>
        );
    }

    if (timeLeft === null) return null;

    const days    = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours   = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    const pad = (n) => String(n).padStart(2, '0');

    let colorClass = 'bg-green-100 text-green-700';
    if (days < 30) colorClass = 'bg-yellow-100 text-yellow-700';
    if (days < 7)  colorClass = 'bg-red-100 text-red-700';

    return (
        <div className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium ${colorClass}`}>
            <Clock size={14} />
            <span>{days > 0 ? `${days} дн ` : ''}{pad(hours)}:{pad(minutes)}:{pad(seconds)}</span>
        </div>
    );
};

// ===== ОСНОВНОЙ КОМПОНЕНТ TreeStructure =====

const TreeStructure = ({ tarif: initialTarif, level: initialLevel, numberLevel: initialNumberLevel, onBack }) => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userClones, setUserClones] = useState(0);
    const [marketingType, setMarketingType] = useState(2);
    const [bronPosition, setBronPosition] = useState(null);
    const [availableTariffs, setAvailableTariffs] = useState([]);
    const [activationDetails, setActivationDetails] = useState(null);
    const [nextPersonalCloneLink, setNextPersonalCloneLink] = useState(null);
    const [clonesModalOpen, setClonesModalOpen] = useState(false);

    // НОВОЕ: Состояние для проверки активации текущего уровня
    const [isCurrentLevelActivated, setIsCurrentLevelActivated] = useState(true);
    const [buyLevelModal, setBuyLevelModal] = useState({ isOpen: false });
    const [successModal, setSuccessModal] = useState({ isOpen: false, message: '', type: 'success' });

    // 🆕 ПОДПИСКА
    const [subscribedUntil, setSubscribedUntil] = useState(undefined);
    const [renewModalOpen, setRenewModalOpen] = useState(false);

    // Текущие параметры для запроса
    const [currentTarif, setCurrentTarif] = useState(initialTarif);
    const [currentLevel, setCurrentLevel] = useState(initialLevel);
    const [currentNumberLevel, setCurrentNumberLevel] = useState(initialNumberLevel);
    const [currentMentorId, setCurrentMentorId] = useState(0);
    const [activeLevel, setActiveLevel] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [shouldLoadTree, setShouldLoadTree] = useState(false);

    // Состояния для модальных окон
    const [bookingModal, setBookingModal] = useState({ isOpen: false, position: null });
    const [purchaseModal, setPurchaseModal] = useState({ isOpen: false, position: null });
    const [historyModal, setHistoryModal] = useState({ isOpen: false, position: null, history: [] });

    // ============= 1. ИНИЦИАЛИЗАЦИЯ (ИСПРАВЛЕНО) =============
    useEffect(() => {
        const tarifParam = searchParams.get('tarif');
        const levelParam = searchParams.get('level');
        const mentorParam = searchParams.get('mentor');

        if (!tarifParam || !levelParam || mentorParam === null) {
            const params = new URLSearchParams();
            params.set('program', '1');
            params.set('tarif', initialTarif);
            params.set('level', initialLevel.toString());
            params.set('mentor', '0');
            setSearchParams(params, { replace: true });

            setCurrentTarif(initialTarif);
            setCurrentLevel(initialLevel);
            setCurrentNumberLevel(initialNumberLevel);
            setCurrentMentorId(0);
        } else {
            setCurrentTarif(tarifParam);
            setCurrentLevel(parseInt(levelParam));
            setCurrentMentorId(parseInt(mentorParam));
            setCurrentNumberLevel(initialNumberLevel);
        }

        setIsInitialized(true);
    }, []);

    // НОВЫЕ ФУНКЦИИ: Покупка уровня
    const handleBuyLevel = () => {
        const tariffData = availableTariffs.find(t => t.name === currentTarif);
        setBuyLevelModal({
            isOpen: true,
            tarif: currentTarif,
            level: currentLevel,
            displayTarif: tariffData?.display_name || currentTarif
        });
    };

    const handleBuySuccess = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'success' });
        setTimeout(() => {
            checkCurrentLevelActivation();
            loadTreeData();
        }, 1000);
    };

    const handleBuyError = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'error' });
    };

    // 🆕 ПОДПИСКА: загрузка статуса при монтировании
    useEffect(() => {
        loadActivityStatus();
    }, []);

    const loadActivityStatus = async () => {
        try {
            const response = await marketingService.getActivityStatus();
            if (response.success) {
                setSubscribedUntil(response.data?.subscribed_until || null);
            }
        } catch (error) {
            console.error('Error loading activity status:', error);
        }
    };

    const handleRenewSuccess = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'success' });
        loadActivityStatus();
    };

    const handleRenewError = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'error' });
    };

    // Загружаем доступные опции
    useEffect(() => {
        loadAvailableOptions();
        loadActivationDetails();
    }, []);

    // ============= 2. ОТСЛЕЖИВАНИЕ ИЗМЕНЕНИЙ GET-параметров =============
    useEffect(() => {
        const programParam = searchParams.get('program');
        const tarifParam = searchParams.get('tarif');
        const levelParam = searchParams.get('level');
        const mentorParam = searchParams.get('mentor');

        const effectiveTarif = tarifParam || programParam;

        if (effectiveTarif && levelParam && mentorParam !== null && availableTariffs.length > 0) {
            const newTarif = effectiveTarif;
            const newLevel = parseInt(levelParam);
            const newMentor = parseInt(mentorParam);

            const tariffData = availableTariffs.find(t => t.name === newTarif);

            if (tariffData) {
                const levelData = tariffData.levels.find(l => l.level === newLevel);

                if (levelData) {
                    if (currentTarif !== newTarif ||
                        currentLevel !== newLevel ||
                        currentNumberLevel !== levelData.number_level ||
                        currentMentorId !== newMentor) {

                        setCurrentTarif(newTarif);
                        setCurrentLevel(newLevel);
                        setCurrentNumberLevel(levelData.number_level);
                        setActiveLevel(levelData);
                        setCurrentMentorId(newMentor);
                        setShouldLoadTree(true);
                    }
                }
            }
        }
    }, [searchParams, availableTariffs]);

    // ============= 3. ЗАГРУЗКА ДЕРЕВА (ИСПРАВЛЕНО) =============
    useEffect(() => {
        if (isInitialized && shouldLoadTree && currentTarif && currentLevel) {
            console.log('🔄 Перезагрузка дерева');

            checkCurrentLevelActivation().then(isActivated => {
                if (isActivated) {
                    loadTreeData();
                } else {
                    console.log('⚠️ Уровень не активирован, дерево не загружается');
                    setLoading(false);
                    setTreeData([]);
                }
            });

            setShouldLoadTree(false);
        }
    }, [shouldLoadTree, isInitialized, currentTarif, currentLevel]);

    useEffect(() => {
        if (!searchQuery) {
            setSearchResults([]);
            setShowSearchResults(false);
            return;
        }

        const timeoutId = setTimeout(() => {
            searchLoginInTree(searchQuery);
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [searchQuery, currentTarif, currentLevel]);

    useEffect(() => {
        if (isInitialized && availableTariffs.length > 0 && !shouldLoadTree && currentTarif && currentLevel) {
            const tariffData = availableTariffs.find(t => t.name === currentTarif);
            if (tariffData) {
                const levelData = tariffData.levels.find(l => l.level === currentLevel);
                if (levelData && currentNumberLevel !== levelData.number_level) {
                    setCurrentNumberLevel(levelData.number_level);
                    setActiveLevel(levelData);
                }
            }
            setShouldLoadTree(true);
        }
    }, [availableTariffs, isInitialized]);

    // НОВЫЙ useEffect: Проверка активации при смене уровня
    useEffect(() => {
        if (currentTarif && currentLevel && isInitialized) {
            console.log('🔄 Изменился уровень:', currentTarif, currentLevel);
            checkCurrentLevelActivation();
        }
    }, [currentTarif, currentLevel, isInitialized]);

    const loadAvailableOptions = async () => {
        try {
            const response = await marketingService.getLightBoxOptions();
            if (response.success) {
                setAvailableTariffs(response.data.tariffs);
            }
        } catch (error) {
            console.error('Error loading options:', error);
        }
    };

    const navigateToFoundNode = (result) => {
        console.log('Переход к узлу:', result);

        const params = new URLSearchParams();
        params.set('program', result.tarif);
        params.set('tarif', result.tarif);
        params.set('level', result.level.toString());
        params.set('mentor', result.position_id.toString());

        setSearchParams(params);
        setShowSearchResults(false);
        setSearchQuery('');
        setShouldLoadTree(true);
    };

    const searchLoginInTree = async (query) => {
        if (!query || query.trim().length === 0) {
            setSearchResults([]);
            setShowSearchResults(false);
            return;
        }

        setIsSearching(true);

        try {
            const result = await marketingService.searchLoginInTree(
                query,
                currentTarif,
                currentLevel
            );

            if (result.success) {
                const formattedResults = result.data.results.map(item => ({
                    login: item.login,
                    original_login: item.original_login,
                    position_id: item.position_id,
                    mentor_id: item.mentor_id,
                    position: item.position,
                    tarif: item.tarif,
                    level: item.level,
                    number_level: item.number_level,
                    typeLabel: item.type_label,
                    typeIcon: item.clone_type === 'technical' ? 'Cpu' :
                        item.clone_type === 'personal' ? 'Users' : 'User',
                    typeColor: item.clone_type === 'technical' ? 'from-purple-500 to-purple-600' :
                        item.clone_type === 'personal' ? 'from-green-500 to-green-600' :
                            'from-blue-500 to-blue-600',
                    clone_number: item.clone_number,
                    avatar: item.avatar,
                    created_at: item.created_at
                }));

                setSearchResults(formattedResults);
                setShowSearchResults(true);
            } else {
                setSearchResults([]);
                setShowSearchResults(true);
            }
        } catch (error) {
            console.error('Search error:', error);
            setSearchResults([]);
            setShowSearchResults(true);
        } finally {
            setIsSearching(false);
        }
    };

    const getTypeIcon = (iconName) => {
        switch(iconName) {
            case 'Users': return Users;
            case 'Cpu': return Cpu;
            default: return User;
        }
    };

    const loadActivationDetails = async () => {
        try {
            const response = await marketingService.checkActivation();
            if (response.success && response.data.is_activated) {
                setActivationDetails(response.data.activation_details);
            }
        } catch (error) {
            console.error('Error loading activation details:', error);
        }
    };

    // НОВАЯ ФУНКЦИЯ: Проверка активации текущего уровня
    const checkCurrentLevelActivation = async () => {
        console.log('🔍 Проверка активации уровня:', {
            tarif: currentTarif,
            level: currentLevel
        });

        try {
            const response = await marketingService.checkLevelActivation(currentTarif, currentLevel);

            console.log('📥 Ответ checkLevelActivation:', response);

            if (response.success) {
                const isActivated = response.data.is_activated;
                setIsCurrentLevelActivated(isActivated);

                console.log(isActivated ? '✅ Уровень активирован' : '⚠️ Уровень НЕ активирован');

                return isActivated;
            } else {
                console.error('❌ Ошибка в ответе:', response);
                setIsCurrentLevelActivated(false);
                return false;
            }
        } catch (error) {
            console.error('💥 Ошибка запроса checkLevelActivation:', error);
            setIsCurrentLevelActivated(false);
            return false;
        }
    };

    const loadTreeData = async () => {
        console.log('🔄 Начало loadTreeData');

        const isActivated = await checkCurrentLevelActivation();

        if (!isActivated) {
            console.log('⚠️ Уровень не активирован, дерево не загружается');
            setLoading(false);
            setTreeData([]);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            console.log('Loading tree with params:', {
                program: 1,
                tarif: currentTarif,
                level: currentLevel,
                number_level: currentNumberLevel,
                mentor_id: currentMentorId
            });

            const response = await marketingService.viewPosition({
                program: 1,
                tarif: currentTarif,
                level: currentLevel,
                number_level: currentNumberLevel,
                mentor_id: currentMentorId
            });

            console.log('Tree data response:', response);

            if (response.success) {
                setTreeData(response.data.data || []);
                setUserClones(response.data.count_clones || 0);
                setMarketingType(response.data.marketing_type || 2);
                setBronPosition(response.data.bron_position || null);
                setNextPersonalCloneLink(response.data.next_personal_clone_link || null);
            } else {
                setError(response.message || 'Ошибка загрузки данных');
            }
        } catch (err) {
            console.error('Error loading tree:', err);
            setError(err.message || 'Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    const handleCancelBron = async () => {
        try {
            const response = await marketingService.cancelBron({
                program: 1,
                tarif: currentTarif,
                level: currentLevel,
                number_level: currentNumberLevel
            });

            if (response.success) {
                setSuccessModal({
                    isOpen: true,
                    message: 'Бронь отменена!',
                    type: 'success'
                });
                setShouldLoadTree(true);
            }
        } catch (err) {
            setSuccessModal({
                isOpen: true,
                message: err.message || 'Ошибка при отмене брони',
                type: 'error'
            });
        }
    };

    const handleBookSuccess = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'success' });
        setShouldLoadTree(true);
    };

    const handleBookError = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'error' });
    };

    const handlePurchaseSuccess = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'success' });
        setShouldLoadTree(true);
    };

    const handlePurchaseError = (message) => {
        setSuccessModal({ isOpen: true, message, type: 'error' });
    };

    const handleBookPosition = (emptyPosition) => {
        setBookingModal({
            isOpen: true,
            position: emptyPosition
        });
    };

    const handlePurchasePosition = (emptyPosition) => {
        setPurchaseModal({
            isOpen: true,
            position: emptyPosition
        });
    };

    const handleShowHistory = (node) => {
        setHistoryModal({
            isOpen: true,
            position: node,
            history: node.history || []
        });
    };

    // ============= НАВИГАЦИЯ =============

    const handleAscendentNavigation = (ascData) => {
        console.log('Ascendent data received:', ascData);

        if (!ascData || !ascData.link) {
            alert('Ссылка для перехода недоступна');
            return;
        }

        try {
            const url = new URL(ascData.link);
            const urlParams = new URLSearchParams(url.search);

            const newProgram = urlParams.get('program');
            const newTarif = urlParams.get('tarif');
            const newLevel = urlParams.get('level');
            const newMentor = urlParams.get('mentor');

            console.log('Parsed URL params:', { newProgram, newTarif, newLevel, newMentor });

            const effectiveTarif = newTarif || newProgram;

            if (effectiveTarif && newLevel && newMentor !== null) {
                const params = new URLSearchParams();
                params.set('program', effectiveTarif);
                params.set('tarif', effectiveTarif);
                params.set('level', newLevel);
                params.set('mentor', newMentor);
                setSearchParams(params);
            }
        } catch (err) {
            console.error('Error parsing ascendent link:', err);
            alert('Ошибка обработки ссылки');
        }
    };

    const handleNextPersonalClone = () => {
        if (!nextPersonalCloneLink) {
            alert('Ссылка недоступна');
            return;
        }

        try {
            const url = new URL(nextPersonalCloneLink);
            const urlParams = new URLSearchParams(url.search);

            const newProgram = urlParams.get('program');
            const newTarif = urlParams.get('tarif');
            const newLevel = urlParams.get('level');
            const newMentor = urlParams.get('mentor');

            const effectiveTarif = newTarif || newProgram;

            if (effectiveTarif && newLevel && newMentor !== null) {
                const params = new URLSearchParams();
                params.set('program', effectiveTarif);
                params.set('tarif', effectiveTarif);
                params.set('level', newLevel);
                params.set('mentor', newMentor);
                setSearchParams(params);

                const tariffData = availableTariffs.find(t => t.name === effectiveTarif);

                if (tariffData) {
                    const levelData = tariffData.levels.find(l => l.level === parseInt(newLevel));

                    if (levelData) {
                        setCurrentTarif(effectiveTarif);
                        setCurrentLevel(parseInt(newLevel));
                        setCurrentNumberLevel(levelData.number_level);
                        setCurrentMentorId(parseInt(newMentor));
                        setActiveLevel(levelData);

                        setShouldLoadTree(true);
                    }
                }
            }
        } catch (err) {
            console.error('Error parsing personal clone link:', err);
            alert('Ошибка обработки ссылки');
        }
    };

    const transformNodeData = (card) => {
        if (!card || card.position_empty) {
            return {
                filled: false,
                login: '',
                avatar: null,
                installDate: null,
                position_id: card?.position_id || null,
                mentor_id: card?.mentor_id || null,
                position: card?.position || null,
                bron: card?.bron || false,
                pay: card?.pay || false,
                active_bron: card?.active_bron || false,
                can_cancel_bron: card?.can_cancel_bron || false,  // ✅ Добавили новый флаг
                isBooked: card?.active_bron || false,
                canGoUp: false,
                canGoDown: false,
                history: [],
                asc: false
            };
        }

        let cloneType = 'root';

        if (card.is_technical) {
            cloneType = 'technical';
        } else if (card.is_personal) {
            cloneType = 'personal';
        } else if (card.clones > 0) {
            if (card.user_id === 0) {
                cloneType = 'technical';
            } else if (card.user_id > 0) {
                cloneType = 'personal';
            }
        }

        const canGoUp = card.up !== false && card.up !== null;
        const canGoDown = card.down !== false && card.down !== null;

        return {
            filled: true,
            login: card.login,
            avatar: card.avatar || null,
            installDate: card.date || card.created_at || null,
            position_id: card.position_id,
            mentor_id: card.up || null,
            user_id: card.user_id,
            clones: card.clones || 0,
            closed: card.closed || 0,
            cloneType: cloneType,
            canGoUp: canGoUp,
            canGoDown: canGoDown,
            downId: card.down,
            tarif: card.tarif,
            level: card.level,
            number_level: card.number_level,
            history: card.history || [],
            ascendent: card.asc || false,
        };
    };

    const getNodeType = (node, isRoot = false) => {
        if (!node || !node.filled) return 'empty';

        if (node.cloneType === 'technical') return 'technical-clone';
        if (node.cloneType === 'personal') return 'personal-clone';
        if (node.clones > 0) return 'clone';

        if (isRoot) return 'root';

        return 'root';
    };

    const handleGoUp = (node) => {
        if (!node.canGoUp || !node.mentor_id) {
            alert('Невозможно подняться выше');
            return;
        }

        const params = new URLSearchParams(searchParams);
        params.set('mentor', node.mentor_id.toString());
        setSearchParams(params);
    };

    const handleGoDown = (node) => {
        if (!node.canGoDown || !node.downId) {
            alert('У этого узла нет подчинённых');
            return;
        }

        const params = new URLSearchParams(searchParams);
        params.set('mentor', node.downId.toString());
        setSearchParams(params);
    };

    const handleBackToRoot = () => {
        const params = new URLSearchParams(searchParams);
        params.set('mentor', '0');
        setSearchParams(params);
    };

    const handleTariffChange = (newTariff) => {
        const tariffData = availableTariffs.find(t => t.name === newTariff);

        if (tariffData && tariffData.levels.length > 0) {
            const firstLevel = tariffData.levels[0];

            const params = new URLSearchParams();
            params.set('program', newTariff);
            params.set('tarif', newTariff);
            params.set('level', firstLevel.level.toString());
            params.set('mentor', '0');
            setSearchParams(params);
        }
    };

    const handleLevelChange = (levelPrice) => {
        const tariffData = availableTariffs.find(t => t.name === currentTarif);
        const levelData = tariffData?.levels.find(l => l.level === parseInt(levelPrice));

        if (levelData) {
            const params = new URLSearchParams();
            params.set('program', currentTarif);
            params.set('tarif', currentTarif);
            params.set('level', levelData.level.toString());
            params.set('mentor', '0');
            setSearchParams(params);
        }
    };

    const getNodesByParent = (parentNode) => {
        if (!parentNode || !parentNode.filled) {
            return Array(marketingType).fill({ filled: false });
        }

        const parentPositionId = parentNode.position_id;

        const isParentTechnical = parentNode.cloneType === 'technical' || parentNode.is_technical;

        const children = treeData.filter(node => {
            if (node && node.up === parentPositionId) {
                return true;
            }
            if (node && node.position_empty && node.mentor_id === parentPositionId) {
                return true;
            }
            return false;
        });

        children.sort((a, b) => {
            const posA = a.position || 0;
            const posB = b.position || 0;
            return posA - posB;
        });

        const result = [];

        for (let i = 0; i < marketingType; i++) {
            const child = children[i];

            if (child) {
                if (child.position_empty) {
                    result.push({
                        filled: false,
                        position: child.position,
                        mentor_id: child.mentor_id,
                        position_id: child.position_id,
                        bron: isParentTechnical ? false : (child.bron || false),
                        pay: isParentTechnical ? false : (child.pay || false),
                        active_bron: child.active_bron || false
                    });
                } else {
                    result.push(transformNodeData(child));
                }
            } else {
                result.push({
                    filled: false,
                    position: i + 1,
                    mentor_id: parentPositionId,
                    bron: false,
                    pay: false,
                    active_bron: false
                });
            }
        }

        return result;
    };

    const getLevelPrice = () => {
        return currentLevel;
    };

    if (!isInitialized || loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-[#d5ebe6] to-white flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#2b6c8e] mx-auto mb-4"></div>
                    <p className="text-gray-600">Загрузка структуры...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-[#d5ebe6] to-white flex items-center justify-center p-6">
                <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full">
                    <div className="text-center">
                        <AlertCircle size={48} className="text-red-500 mx-auto mb-4" />
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Ошибка</h3>
                        <p className="text-gray-600 mb-6">{error}</p>
                        <button
                            onClick={() => setShouldLoadTree(true)}
                            className="px-6 py-2 bg-[#2b6c8e] text-white rounded-lg hover:bg-opacity-90 transition">
                            Попробовать снова
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const rootNode = treeData[0] ? transformNodeData(treeData[0]) : { filled: false };
    const level1Nodes = treeData.slice(1, 1 + marketingType).map(transformNodeData);
    const level2Nodes = treeData.slice(1 + marketingType).map(transformNodeData);

    if (rootNode.filled) {
        rootNode.isRootPosition = true;
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#d5ebe6] to-white py-6 px-4">
            <div className="max-w-7xl mx-auto">
                {/* ── ШАПКА: кнопка назад + таймер + продлить + мои клоны ── */}
                <div className="mb-4 sm:mb-6 flex flex-wrap items-center gap-2 sm:gap-3">
                    <button
                        onClick={() => {
                            navigate('/dashboard/clusters');
                            if (onBack) onBack();
                        }}
                        className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow hover:shadow-md transition text-gray-700 font-medium">
                        <ChevronsLeft size={20}/>
                        <span>Назад к кластерам</span>
                    </button>

                    {/* 🆕 Таймер подписки */}
                    <SubscriptionTimer subscribedUntil={subscribedUntil} />

                    {/* 🆕 Кнопка продлить */}
                    {subscribedUntil !== undefined && (
                        <button
                            onClick={() => setRenewModalOpen(true)}
                            className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-lg hover:from-indigo-600 hover:to-purple-600 transition text-sm shadow-md font-medium">
                            <RefreshCw size={16}/>
                            <span>Продлить активность</span>
                        </button>
                    )}

                    {/* 🆕 НОВАЯ КНОПКА - Мои клоны */}
                    <button
                        onClick={() => setClonesModalOpen(true)}
                        className="flex items-end gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition text-sm sm:text-base shadow-lg font-medium"
                    >
                        <Package size={18} />
                        <span>Мои клоны</span>
                    </button>
                </div>

                {/* Информация об активации и кнопки */}
                <div className="mb-6 sm:mb-8">
                    <div className="bg-white rounded-2xl shadow-md p-4 sm:p-6">
                        {availableTariffs && availableTariffs.length > 0 && (
                            <div className="mb-4 flex flex-col sm:flex-row gap-2 sm:gap-3">
                                <select
                                    value={currentTarif}
                                    onChange={(e) => handleTariffChange(e.target.value)}
                                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium bg-white shadow-sm"
                                >
                                    {availableTariffs.map(tariffItem => (
                                        <option key={tariffItem.name} value={tariffItem.name}>
                                            Тариф {tariffItem.display_name}
                                        </option>
                                    ))}
                                </select>

                                {availableTariffs.find(t => t.name === currentTarif)?.levels && (
                                    <select
                                        value={currentLevel}
                                        onChange={(e) => handleLevelChange(e.target.value)}
                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium bg-white shadow-sm"
                                    >
                                        {availableTariffs.find(t => t.name === currentTarif).levels.map(levelItem => (
                                            <option key={levelItem.level} value={levelItem.level}>
                                                Уровень {levelItem.number_level} - {levelItem.level} $
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        )}

                        {/* Информация о текущем тарифе */}
                        <div className="bg-gradient-to-r from-blue-50 to-white rounded-xl p-4">
                            <h4 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base">
                                Информация о тарифе
                            </h4>
                            <p className="text-xs sm:text-sm text-gray-600">
                                Текущий тариф: <span className="font-medium text-blue-500">
                                    {availableTariffs.find(t => t.name === currentTarif)?.display_name || 'Не активирован'}
                                </span> |
                                Уровень: <span className="font-medium text-blue-500">
                                    {currentLevel || '-'}
                                </span>
                                {isCurrentLevelActivated ? (
                                    <span className="ml-2 text-green-600 font-medium">✓ Активирован</span>
                                ) : (
                                    <span className="ml-2 text-yellow-600 font-medium">⚠ Не активирован</span>
                                )}
                            </p>
                        </div>

                        {/* НОВОЕ: Кнопка покупки уровня */}
                        {!isCurrentLevelActivated && (
                            <div className="mt-4">
                                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                                    <div className="flex items-start gap-3 mb-3">
                                        <AlertCircle size={20} className="text-yellow-600 flex-shrink-0 mt-0.5" />
                                        <div className="flex-1">
                                            <p className="text-sm font-medium text-yellow-800 mb-1">
                                                Уровень не активирован
                                            </p>
                                            <p className="text-xs text-yellow-700">
                                                Этот уровень еще не куплен. Вы можете купить его сейчас и система автоматически расставит вас в структуру.
                                            </p>
                                        </div>
                                    </div>
                                    <button
                                        onClick={handleBuyLevel}
                                        className="w-full px-4 py-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg hover:shadow-lg transition font-medium flex items-center justify-center gap-2"
                                    >
                                        <DollarSign size={18} />
                                        <span>Купить уровень ({currentLevel} $)</span>
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 mt-4">
                            {currentMentorId !== 0 && (
                                <button
                                    onClick={handleBackToRoot}
                                    className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors flex items-center justify-center text-sm sm:text-base whitespace-nowrap">
                                    <ArrowUpCircle size={18} className="mr-2"/>
                                    К корню
                                </button>
                            )}

                            {isCurrentLevelActivated && nextPersonalCloneLink && (
                                <button
                                    onClick={handleNextPersonalClone}
                                    className="w-full sm:w-auto px-4 py-2 bg-gradient-to-r from-teal-500 to-emerald-500 text-white rounded-full hover:shadow-lg transition-all flex items-center justify-center text-sm sm:text-base whitespace-nowrap">
                                    <User size={18} className="mr-2"/>
                                    Следующий клон
                                </button>
                            )}

                            {bronPosition && (
                                <button
                                    onClick={handleCancelBron}
                                    className="w-full sm:w-auto px-4 py-2 bg-yellow-400 text-gray-800 rounded-full hover:bg-yellow-500 transition-colors flex items-center justify-center text-sm sm:text-base whitespace-nowrap">
                                    Отменить бронь
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                {/* Поиск по логину */}
                {isCurrentLevelActivated && (

                    <div className="mb-8 max-w-2xl mx-auto">
                        <div className="relative">
                            <div className="flex items-center bg-white rounded-xl shadow-lg border-2 border-[#a7d7cd] focus-within:border-[#2b6c8e] transition-colors">
                                <div className="pl-4 pr-2">
                                    <Search className="text-gray-400" size={20} />
                                </div>

                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Поиск по логину в дереве..."
                                    className="flex-1 py-3 px-2 bg-transparent outline-none text-gray-800 placeholder-gray-400"
                                />

                                {searchQuery && (
                                    <button
                                        onClick={() => {
                                            setSearchQuery('');
                                            setSearchResults([]);
                                            setShowSearchResults(false);
                                        }}
                                        className="pr-4 pl-2 text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        <X size={20} />
                                    </button>
                                )}
                            </div>

                            {/* Результаты поиска */}
                            {showSearchResults && (
                                <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border-2 border-[#a7d7cd] overflow-hidden z-50 max-h-96 overflow-y-auto">
                                    {isSearching ? (
                                        <div className="p-8 text-center">
                                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2b6c8e] mx-auto"></div>
                                            <p className="text-gray-500 mt-4">Поиск...</p>
                                        </div>
                                    ) : searchResults.length > 0 ? (
                                        <div className="divide-y divide-gray-100">
                                            <div className="px-4 py-3 bg-gradient-to-r from-[#d5ebe6] to-[#a7d7cd]">
                                                <p className="text-sm font-semibold text-gray-700">
                                                    Найдено результатов: {searchResults.length}
                                                </p>
                                            </div>

                                            {searchResults.map((result, index) => {
                                                const IconComponent = getTypeIcon(result.typeIcon);
                                                return (
                                                    <button
                                                        key={`${result.position_id}-${index}`}
                                                        onClick={() => navigateToFoundNode(result)}
                                                        className="w-full px-4 py-4 hover:bg-gradient-to-r hover:from-[#d5ebe6] hover:to-white transition-all flex items-center justify-between group"
                                                    >
                                                        <div className="flex items-center gap-3">
                                                            <div className={`p-2 rounded-lg bg-gradient-to-r ${result.typeColor} flex items-center justify-center`}>
                                                                <IconComponent size={20} className="text-white" />
                                                            </div>

                                                            <div className="text-left">
                                                                <p className="font-semibold text-gray-800 text-lg">
                                                                    <Nt>{result.login}</Nt>
                                                                </p>
                                                                <p className="text-sm text-gray-500">
                                                                    {result.typeLabel} • ID: {result.position_id} • Позиция: {result.position}
                                                                </p>
                                                                {result.created_at && (
                                                                    <p className="text-xs text-gray-400">
                                                                        {result.created_at}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <ChevronRight
                                                            size={20}
                                                            className="text-gray-400 group-hover:text-[#2b6c8e] group-hover:translate-x-1 transition-all"
                                                        />
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="p-8 text-center">
                                            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                                                <Search size={32} className="text-gray-400" />
                                            </div>
                                            <p className="text-gray-600 font-medium mb-1">
                                                Ничего не найдено
                                            </p>
                                            <p className="text-gray-400 text-sm">
                                                Попробуйте изменить поисковый запрос
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {!showSearchResults && (
                            <p className="mt-2 text-sm text-gray-500 text-center">
                                Введите логин для поиска в дереве
                            </p>
                        )}
                    </div>
                )}
                {/* Матрица - мобильная версия */}

                <div className="block md:hidden mb-6">
                    <div className="bg-gradient-to-b from-gray-50 to-white rounded-xl p-4 shadow-md">
                        <div className="flex justify-center mb-6">
                            <div className="w-32">
                                <UltraModernCard
                                    node={{...rootNode, isRootPosition: true}}
                                    type={getNodeType(rootNode, true)}
                                    size="medium"
                                    onGoUp={handleGoUp}
                                    onGoDown={handleGoDown}
                                    onShowHistory={handleShowHistory}
                                    onAscendent={handleAscendentNavigation}
                                />
                            </div>
                        </div>

                        {/* Линии соединения для уровня 1 */}
                        {marketingType === 3 ? (
                            <div className="relative flex justify-center mb-3 h-10">
                                <div
                                    className="absolute top-0 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                <div className="absolute top-1/2 w-2/3 h-px bg-blue-500/20"></div>
                                <div className="absolute top-1/2 left-1/6 w-px h-1/2 bg-blue-500/20"></div>
                                <div
                                    className="absolute top-1/2 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                <div className="absolute top-1/2 right-1/6 w-px h-1/2 bg-blue-500/20"></div>
                            </div>
                        ) : (
                            <div className="relative flex justify-center mb-3 h-10">
                                <div
                                    className="absolute top-0 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                <div className="absolute top-1/2 left-1/4 right-1/4 h-px bg-blue-500/20"></div>
                                <div className="absolute top-1/2 left-1/4 w-px h-1/2 bg-blue-500/20"></div>
                                <div className="absolute top-1/2 right-1/4 w-px h-1/2 bg-blue-500/20"></div>
                            </div>
                        )}

                        {/* Узлы первого уровня - мобильная */}
                        {marketingType === 3 ? (
                            <div className="grid grid-cols-3 gap-2 mb-4">
                                {level1Nodes.map((node, index) => (
                                    <div key={index}>
                                        <div
                                            className={`${node.isBooked ? 'ring-4 ring-yellow-400 ring-opacity-60 rounded-2xl p-1 animate-pulse' : ''}`}>
                                            <UltraModernCard
                                                node={node}
                                                type={getNodeType(node)}
                                                cloneNumber={index + 1}
                                                size="small"
                                                hideDate={true}
                                                onGoUp={handleGoUp}
                                                onGoDown={handleGoDown}
                                                onShowHistory={handleShowHistory}
                                                onAscendent={handleAscendentNavigation}
                                            />
                                        </div>
                                        {!node.filled && (
                                            <div className="flex gap-1 mt-1 justify-center">
                                                {node.bron && !node.isBooked && (
                                                    <button
                                                        onClick={() => handleBookPosition(node)}
                                                        className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition text-xs flex items-center gap-1"
                                                        title="Забронировать">
                                                        <Lock size={12}/>
                                                        <span>Бронь</span>
                                                    </button>
                                                )}
                                                {node.pay && (
                                                    <button
                                                        onClick={() => handlePurchasePosition(node)}
                                                        className="px-2 py-1 bg-teal-500 text-white rounded hover:bg-teal-600 transition text-xs flex items-center gap-1"
                                                        title="Купить">
                                                        <ShoppingCart size={12}/>
                                                        <span>Купить</span>
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                        {!node.filled && node.isBooked && (
                                            <div className="flex justify-center mt-1">
                                                <span
                                                    className="px-2 py-1 bg-yellow-400 text-gray-800 rounded text-xs font-semibold flex items-center gap-1">
                                                    <Lock size={12}/>
                                                    Забронировано
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="flex justify-center gap-2 mb-4">
                                {level1Nodes.map((node, index) => (
                                    <div key={index} className="w-36">
                                        <div
                                            className={`${node.isBooked ? 'ring-4 ring-yellow-400 ring-opacity-60 rounded-2xl p-1 animate-pulse' : ''}`}>
                                            <UltraModernCard
                                                node={node}
                                                type={getNodeType(node)}
                                                cloneNumber={index + 1}
                                                size="small"
                                                hideDate={true}
                                                onGoUp={handleGoUp}
                                                onGoDown={handleGoDown}
                                                onShowHistory={handleShowHistory}
                                                onAscendent={handleAscendentNavigation}
                                            />
                                        </div>
                                        {!node.filled && (
                                            <div className="flex gap-1 mt-1 justify-center">
                                                {node.bron && !node.isBooked && (
                                                    <button
                                                        onClick={() => handleBookPosition(node)}
                                                        className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition text-xs flex items-center gap-1"
                                                        title="Забронировать">
                                                        <Lock size={12}/>
                                                        <span>Бронь</span>
                                                    </button>
                                                )}
                                                {node.pay && (
                                                    <button
                                                        onClick={() => handlePurchasePosition(node)}
                                                        className="px-2 py-1 bg-teal-500 text-white rounded hover:bg-teal-600 transition text-xs flex items-center gap-1"
                                                        title="Купить">
                                                        <ShoppingCart size={12}/>
                                                        <span>Купить</span>
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                        {!node.filled && node.isBooked && (
                                            <div className="flex justify-center mt-1">
                                                <span
                                                    className="px-2 py-1 bg-yellow-400 text-gray-800 rounded text-xs font-semibold flex items-center gap-1">
                                                    <Lock size={12}/>
                                                    Забронировано
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/*<div className="text-center">*/}
                        {/*    <button className="px-4 py-2 bg-blue-500/10 text-blue-500 rounded-lg text-sm font-medium hover:bg-blue-500/20">*/}
                        {/*        Показать полную структуру →*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                    </div>
                </div>

                {/* Матрица - десктоп версия (ОРИГИНАЛЬНЫЙ КОД БЕЗ ИЗМЕНЕНИЙ) */}
                <div className="hidden md:block mb-8">
                    <div className="bg-gradient-to-b from-gray-50 to-white rounded-2xl p-6 shadow-md">
                        {/* Корневой узел */}
                        <div className="flex justify-center mb-16">
                            <div className="w-64">
                                <UltraModernCard
                                    node={{...rootNode, isRootPosition: true}}
                                    type={getNodeType(rootNode, true)}
                                    size="large"
                                    onGoUp={handleGoUp}
                                    onGoDown={handleGoDown}
                                    onShowHistory={handleShowHistory}
                                    onAscendent={handleAscendentNavigation}
                                />
                            </div>
                        </div>

                        {/* Линии соединения для уровня 1 */}
                        {marketingType === 3 ? (
                            <div className="relative flex justify-center mb-4 h-16">
                                <div
                                    className="absolute top-0 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                <div className="absolute top-1/2 w-2/3 h-px bg-blue-500/20"></div>
                                <div className="absolute top-1/2 left-1/6 w-px h-1/2 bg-blue-500/20"></div>
                                <div
                                    className="absolute top-1/2 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                <div className="absolute top-1/2 right-1/6 w-px h-1/2 bg-blue-500/20"></div>
                            </div>
                        ) : (
                            <div className="relative flex justify-center mb-4 h-16">
                                <div
                                    className="absolute top-0 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                <div className="absolute top-1/2 left-1/3 right-1/3 h-px bg-blue-500/20"></div>
                                <div className="absolute top-1/2 left-1/3 w-px h-1/2 bg-blue-500/20"></div>
                                <div className="absolute top-1/2 right-1/3 w-px h-1/2 bg-blue-500/20"></div>
                            </div>
                        )}

                        {/* Узлы первого уровня - десктоп */}
                        {marketingType === 3 ? (
                            <div className="flex justify-center mb-12">
                                <div className="grid grid-cols-3 gap-16 w-full max-w-4xl">
                                    {level1Nodes.map((node, index) => (
                                        <div key={index} className="flex justify-center flex-col items-center">
                                            <div className="w-48">
                                                <UltraModernCard
                                                    node={node}
                                                    type={getNodeType(node)}
                                                    cloneNumber={index + 1}
                                                    size="medium"
                                                    onGoUp={handleGoUp}
                                                    onGoDown={handleGoDown}
                                                    onShowHistory={handleShowHistory}
                                                    onAscendent={handleAscendentNavigation}
                                                />
                                            </div>
                                            {!node.filled && (
                                                <div className="flex gap-2 mt-2">
                                                    {node.bron && !node.isBooked && (
                                                        <button
                                                            onClick={() => handleBookPosition(node)}
                                                            className="px-3 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition text-sm flex items-center gap-1"
                                                            title="Забронировать">
                                                            <Lock size={14}/>
                                                            <span>Бронь</span>
                                                        </button>
                                                    )}
                                                    {node.pay && (
                                                        <button
                                                            onClick={() => handlePurchasePosition(node)}
                                                            className="px-3 py-1.5 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition text-sm flex items-center gap-1"
                                                            title="Купить">
                                                            <ShoppingCart size={14}/>
                                                            <span>Купить</span>
                                                        </button>
                                                    )}
                                                    {!node.filled && node.isBooked && (
                                                        <div className="flex justify-center mt-1">
                                                            <span
                                                                className="px-2 py-1 bg-yellow-400 text-gray-800 rounded text-xs font-semibold flex items-center gap-1">
                                                                <Lock size={12}/>
                                                                Забронировано
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>

                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div className="flex justify-center gap-24 mb-16 max-w-3xl mx-auto">
                                {level1Nodes.map((node, index) => (
                                    <div key={index} className="flex flex-col items-center">
                                        <div className="w-48">
                                            <UltraModernCard
                                                node={node}
                                                type={getNodeType(node)}
                                                cloneNumber={index + 1}
                                                size="medium"
                                                onGoUp={handleGoUp}
                                                onGoDown={handleGoDown}
                                                onShowHistory={handleShowHistory}
                                                onAscendent={handleAscendentNavigation}
                                            />
                                        </div>
                                        {!node.filled && (node.bron || node.pay) && (
                                            <div className="flex gap-2 mt-2">
                                                {node.bron && (
                                                    <button
                                                        onClick={() => handleBookPosition(node)}
                                                        className="px-3 py-1.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition text-sm flex items-center gap-1">
                                                        <Lock size={14}/>
                                                        <span>Бронь</span>
                                                    </button>
                                                )}
                                                {node.pay && (
                                                    <button
                                                        onClick={() => handlePurchasePosition(node)}
                                                        className="px-3 py-1.5 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition text-sm flex items-center gap-1">
                                                        <ShoppingCart size={14}/>
                                                        <span>Купить</span>
                                                    </button>
                                                )}
                                                {!node.filled && node.isBooked && (
                                                    <div className="flex justify-center mt-1">
                                                            <span
                                                                className="px-2 py-1 bg-yellow-400 text-gray-800 rounded text-xs font-semibold flex items-center gap-1">
                                                                <Lock size={12}/>
                                                                Забронировано
                                                            </span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Линии соединения для уровня 2 */}
                        {marketingType === 3 ? (
                            <div className="grid grid-cols-3 gap-16 mb-4 max-w-4xl mx-auto relative">
                                {level1Nodes.map((parent, idx) => (
                                    <div key={idx} className="flex justify-center relative h-16">
                                        <div
                                            className="absolute top-0 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                        <div className="absolute top-1/2 w-full h-px bg-blue-500/20"></div>
                                        <div className="absolute top-1/2 left-1/6 w-px h-1/2 bg-blue-500/20"></div>
                                        <div
                                            className="absolute top-1/2 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                        <div className="absolute top-1/2 right-1/6 w-px h-1/2 bg-blue-500/20"></div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="flex justify-center gap-24 mb-4 max-w-3xl mx-auto">
                                {level1Nodes.map((parent, idx) => (
                                    <div key={idx} className="relative h-16 w-48">
                                        <div
                                            className="absolute top-0 left-1/2 w-px h-1/2 bg-blue-500/20 transform -translate-x-1/2"></div>
                                        <div className="absolute top-1/2 left-1/4 right-1/4 h-px bg-blue-500/20"></div>
                                        <div className="absolute top-1/2 left-1/4 w-px h-1/2 bg-blue-500/20"></div>
                                        <div className="absolute top-1/2 right-1/4 w-px h-1/2 bg-blue-500/20"></div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Узлы второго уровня */}
                        {marketingType === 3 ? (
                            <div className="grid grid-cols-3 gap-16 max-w-4xl mx-auto">
                                {level1Nodes.map((parent, idx) => {
                                    const childNodes = getNodesByParent(parent);
                                    return (
                                        <div key={idx} className="flex justify-center">
                                            <div className="grid grid-cols-3 gap-2 w-full">
                                                {childNodes.map((node, i) => (
                                                    <div key={i} className="flex flex-col items-center">
                                                        <UltraModernCard
                                                            node={node}
                                                            type={getNodeType(node)}
                                                            size="small"
                                                            hideDate={true}
                                                            onGoUp={handleGoUp}
                                                            onGoDown={handleGoDown}
                                                            onShowHistory={handleShowHistory}
                                                            onAscendent={handleAscendentNavigation}
                                                        />
                                                        {!node.filled && (node.bron || node.pay) && (
                                                            <div className="flex gap-1 mt-1">
                                                                {node.bron && (
                                                                    <button
                                                                        onClick={() => handleBookPosition(node)}
                                                                        className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
                                                                        title="Забронировать">
                                                                        <Lock size={10}/>
                                                                    </button>
                                                                )}
                                                                {node.pay && (
                                                                    <button
                                                                        onClick={() => handlePurchasePosition(node)}
                                                                        className="p-1 bg-teal-500 text-white rounded hover:bg-teal-600 transition"
                                                                        title="Купить">
                                                                        <ShoppingCart size={10}/>
                                                                    </button>
                                                                )}
                                                                {!node.filled && node.isBooked && (
                                                                    <div className="flex justify-center mt-1">
                                                                        <span
                                                                            className="px-2 py-1 bg-yellow-400 text-gray-800 rounded text-xs font-semibold flex items-center gap-1">
                                                                            <Lock size={12}/>
                                                                            Забронировано
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="flex justify-center gap-24 max-w-3xl mx-auto">
                                {level1Nodes.map((parent, idx) => {
                                    const childNodes = getNodesByParent(parent);
                                    return (
                                        <div key={idx} className="flex justify-center gap-2 w-48">
                                            {childNodes.map((node, i) => (
                                                <div key={i} className="flex-1 flex flex-col items-center">
                                                    <UltraModernCard
                                                        node={node}
                                                        type={getNodeType(node)}
                                                        size="small"
                                                        hideDate={true}
                                                        onGoUp={handleGoUp}
                                                        onGoDown={handleGoDown}
                                                        onShowHistory={handleShowHistory}
                                                        onAscendent={handleAscendentNavigation}
                                                    />
                                                    {!node.filled && (node.bron || node.pay) && (
                                                        <div className="flex gap-1 mt-1">
                                                            {node.bron && (
                                                                <button
                                                                    onClick={() => handleBookPosition(node)}
                                                                    className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
                                                                    title="Забронировать">
                                                                    <Lock size={10}/>
                                                                </button>
                                                            )}
                                                            {node.pay && (
                                                                <button
                                                                    onClick={() => handlePurchasePosition(node)}
                                                                    className="p-1 bg-teal-500 text-white rounded hover:bg-teal-600 transition"
                                                                    title="Купить">
                                                                    <ShoppingCart size={10}/>
                                                                </button>
                                                            )}
                                                            {!node.filled && node.isBooked && (
                                                                <div className="flex justify-center mt-1">
                                                            <span
                                                                className="px-2 py-1 bg-yellow-400 text-gray-800 rounded text-xs font-semibold flex items-center gap-1">
                                                                <Lock size={12}/>
                                                                Забронировано
                                                            </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>

            </div>

            {/* Модальные окна */}
            <BookingModal
                isOpen={bookingModal.isOpen}
                onClose={() => setBookingModal({isOpen: false, position: null})}
                position={bookingModal.position}
                tarif={currentTarif}
                level={currentLevel}
                numberLevel={currentNumberLevel}
                onSuccess={handleBookSuccess}
                onError={handleBookError}
            />

            <PurchaseModal
                isOpen={purchaseModal.isOpen}
                onClose={() => setPurchaseModal({isOpen: false, position: null})}
                position={purchaseModal.position}
                tarif={currentTarif}
                level={currentLevel}
                numberLevel={currentNumberLevel}
                price={getLevelPrice()}
                onSuccess={handlePurchaseSuccess}
                onError={handlePurchaseError}
            />

            <SuccessModal
                isOpen={successModal.isOpen}
                onClose={() => setSuccessModal({isOpen: false, message: '', type: 'success'})}
                message={successModal.message}
                type={successModal.type}
            />

            <PositionHistoryModal
                isOpen={historyModal.isOpen}
                onClose={() => setHistoryModal({isOpen: false, position: null, history: []})}
                positionId={historyModal.position?.position_id}
                history={historyModal.history}
            />

            {/* НОВОЕ: Модальное окно покупки */}
            <BuyLevelModal
                isOpen={buyLevelModal.isOpen}
                onClose={() => setBuyLevelModal({ isOpen: false })}
                tarif={buyLevelModal.tarif}
                level={buyLevelModal.level}
                displayTarif={buyLevelModal.displayTarif}
                onSuccess={handleBuySuccess}
                onError={handleBuyError}
            />
            {/* 🆕 НОВАЯ МОДАЛКА - Информация о клонах */}
            <ClonesInfoModal
                isOpen={clonesModalOpen}
                onClose={() => setClonesModalOpen(false)}
            />

            {/* 🆕 НОВАЯ МОДАЛКА - Продление активности */}
            <RenewActivityModal
                isOpen={renewModalOpen}
                onClose={() => setRenewModalOpen(false)}
                onSuccess={handleRenewSuccess}
                onError={handleRenewError}
            />

        </div>
    );
};

export default TreeStructure;
